import { getFeature } from '@/config/featureConfig.js'
import { getCardActions } from '@/config/featureConfig.js'

export class FeatureTogglePlugin {
  static install(Vue, _options) {
    Vue.prototype.$feature = getFeature
    Vue.prototype.$actions = getCardActions()
  }
}
